export default "__VITE_ASSET__BfcG1ra8__"